import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { parseISO, startOfDay, endOfDay, getUnixTime, isToday, subHours } from 'date-fns';
import { MapContainer, TileLayer, Polyline, FeatureGroup, Marker, Tooltip, useMap } from 'react-leaflet';
import { getMarkerIcon } from '../MarkerIcon';

import bluetoothToolService from '../../../../services/BluetoothToolService';
// import { routeHistory } from './demoData';
import { makeStyles } from '@material-ui/core';
import { determineMarkerIcon } from '../MapVehicleItem';

const useStyles = makeStyles({
  leafletInteractive: {
    strokeWidth: 5,
    stroke: '#03a9f4'
  },
  mapComponentWrapper: {
    width: '100%'
  }
});

const ChangeView = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, zoom);
    }
  }, [center, zoom, map]);

  return null;
};

const BeaconMapComponent = ({
  position,
  beaconInstanceID,
  vehicleTabClicked,
  dateString,
  beaconMac,
  clickedVehiclePosition,
  clickedAssetTimestamp
}) => {
  const classes = useStyles();
  const [beaconPosition, setBeaconPosition] = useState([]);
  const vehicleTrackerItem = { timestamp: clickedAssetTimestamp };

  useEffect(() => {
    const fetchBeaconRouteHistory = async () => {
      try {
        // Parse the date string
        const date = parseISO(dateString);
        // Get the start and end of the day
        let fromTimestamp = getUnixTime(startOfDay(date)); // 12:00 AM timestamp
        let toTimestamp = getUnixTime(endOfDay(date)); // 11:59 PM timestamp

        //if employee and date is today then subtract 12hours
        //if admin don't need to subtract
        // eslint-disable-next-line no-undef
        const employeeRole = localStorage.getItem('role');

        // If it's today, lag the timestamps by 12 hours
        if (isToday(new Date(dateString)) && employeeRole === 'User') {
          fromTimestamp = getUnixTime(subHours(startOfDay(date), 12)); // 12 hours lagged
          toTimestamp = getUnixTime(subHours(new Date(), 12)); // Subtract 12 hours from the current time
        }

        const beaconPayload = {
          beaconInstanceID: beaconInstanceID,
          fromTimestamp: fromTimestamp,
          toTimestamp: toTimestamp
        };

        if (beaconMac && vehicleTabClicked === 'route' && dateString) {
          const beaconRouteRecord = await bluetoothToolService.getBeaconRouteHistory(beaconPayload);
          // eslint-disable-next-line no-console, no-undef
          console.log('beaconRouteRecord', beaconRouteRecord);

          const routeHistory = beaconRouteRecord?.data?.data;
          // eslint-disable-next-line no-console, no-undef
          console.log('routeHistory', routeHistory);

          const positions = routeHistory.map((history) => {
            return [history.position.latitude, history.position.longitude];
          });
          setBeaconPosition(positions);
        }
      } catch (error) {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error);
      }
    };

    fetchBeaconRouteHistory();
  }, [beaconInstanceID, dateString, beaconMac, vehicleTabClicked]);

  return (
    <div style={{ display: 'flex', flex: '1' }}>
      <div className={classes.mapComponentWrapper}>
        {vehicleTabClicked === 'route' ? (
          <MapContainer center={position} zoom={11} style={{ height: '100vh', width: '100%' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {beaconPosition?.map((position, index) => {
              return (
                <FeatureGroup key={index}>
                  {index % 2 ? (
                    <Marker key={index} position={position} icon={getMarkerIcon('green')}>
                      <Tooltip direction="right" offset={[25, 20]} opacity={1} permanent>
                        <span>Start</span>
                      </Tooltip>
                    </Marker>
                  ) : (
                    <Marker key={index} position={position} icon={getMarkerIcon('red')}>
                      <Tooltip direction="right" offset={[25, 20]} opacity={1} permanent>
                        <span>End</span>
                      </Tooltip>
                    </Marker>
                  )}

                  <Polyline positions={beaconPosition} color="blue" className={classes.leafletInteractive} />
                </FeatureGroup>
              );
            })}
          </MapContainer>
        ) : (
          <MapContainer
            center={clickedVehiclePosition}
            zoom={13}
            scrollWheelZoom={false}
            style={{ height: '100vh', width: '100%' }}
          >
            <ChangeView center={clickedVehiclePosition} zoom={13} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
              position={clickedVehiclePosition || position}
              icon={determineMarkerIcon(vehicleTrackerItem)}
            ></Marker>
          </MapContainer>
        )}
      </div>
    </div>
  );
};

export default BeaconMapComponent;

BeaconMapComponent.propTypes = {
  position: PropTypes.any,
  beaconInstanceID: PropTypes.any,
  vehicleTabClicked: PropTypes.any,
  dateString: PropTypes.any,
  beaconMac: PropTypes.any,
  clickedVehiclePosition: PropTypes.any,
  clickedAssetTimestamp: PropTypes.any
};

ChangeView.propTypes = { center: PropTypes.any, zoom: PropTypes.any };
